export default __webpack_public_path__ + "static/media/valuable-feedback-giver-badge.19085348.png";